export default __webpack_public_path__ + "static/media/1877.3df79de5.png";